import type { FaireProductEntity } from "../../entity_types/product";

export const p_2f8syf749w: FaireProductEntity = {
  token: "p_2f8syf749w",
  type: "product",
  name: "9 oz. Grapefruit + Citrus Soy Wax Candle",
  brandToken: "b_hma3kre8ec",
  brandName: "Heritage Valley Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/5c8b2c25885172545ea45c5fab10540482b1e09b3a2beb67df177e4684b147ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ad9a48d77cc62516848098892fcbb51c5f16dcc66ee78669090c8d5487bc021.jpeg",
    "https://cdn.faire.com/fastly/cb317ed95d6360d01dadde28398467603098c177fe7b55378d58fc3e6aa5e146.jpeg",
    "https://cdn.faire.com/fastly/1b9c2d6220a3173c66520c1eb5c301e7fab3cc7c17cc5849f2f1ac8e0938cb1f.jpeg",
  ],
  priceDollars: 13,
  description:
    "grapefruit | mango | cedar\n\nThis spring we decided to do a limited run of one of our day 1 scents. This bright, sweet candle is a favorite of many of our longtime friends and family and we are excited to have it back in the rotation!\n\nAll of our fragrances are clean burning & toxin free. Our candles are 100% soy wax, and our labels are made of 100% recycled materials.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:06.526Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
